import { InsightsTablesType } from "../hooks/useInsightsData";

const InsightsBaseKeys = [
  "estimatedTurnover",
  "pieces",
  "numberOfRefillLocations",
] as const;

const ArticleInsightsKeys = ["itemNo", ...InsightsBaseKeys] as const;
const RefilledAreaInsightsKeys = ["refillAreaId", ...InsightsBaseKeys] as const;
const RefilledSalesLocationIDInsightsKeys = [
  "itemRefillLocationGridCode",
  "estimatedTurnover",
  "pieces",
  "numberOfArticles",
] as const;
const ItemHfbTypeInsightsKeys = ["itemHfbNo", ...InsightsBaseKeys] as const;

export const InsightsKeys = {
  articleInsights: ArticleInsightsKeys,
  refilledAreaInsights: RefilledAreaInsightsKeys,
  refilledSalesLocationIDInsights: RefilledSalesLocationIDInsightsKeys,
  itemHfbTypeInsights: ItemHfbTypeInsightsKeys,
};

export const insightsTables = [
  "articleInsights",
  "refilledAreaInsights",
  "refilledSalesLocationIDInsights",
  "itemHfbTypeInsights",
] as InsightsTablesType[];
